export const TEMPLATES = '/templates';
export const STORE_TEMPLATES = '/store-templates';
export const PRODUCTS_URL = '/products';